// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.util_row__JstR {
  display: flex;
  align-items: center;
  break-inside: avoid;
}

.util_justifiedRow_n2nRJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.util_wrappingRow_nQzLm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
}

.util_column_rD5g8 {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  max-height: 100%;
}

.util_centeringColumn_OCH7y {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  max-height: 100%;
}

.util_justifiedColumn_ItdRH {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: space-between;
  height: 100%;
}

/* PlatformSymbol styles */
.util_PScontainer_xlAzu {
  display: block;
}

.util_PScircle_nXnAN {
  fill: none;
  stroke: var(--hsl-blue);
  stroke-width: 3;
}

.util_PStext_u7r3K {
  text-anchor: middle;
  dominant-baseline: middle;
  font-family: GothamRounded-Medium;
  fill: var(--hsl-blue);
}

.util_printBtn_KJfJ7 {
  margin-left: 2rem;
  background-color: var(--hsl-blue);
  margin-top: 1.5rem;
  height: 2rem;
  width: fit-content;
  padding: 0 1rem 0 1rem;
  font-size: 0.9rem;
  border-radius: 10px;
  color: white;
  border: none;
}

.util_printBtn_KJfJ7:hover {
  background-color: white;
  cursor: pointer;
  color: var(--hsl-blue);
  border: 1px solid var(--hsl-blue);
}

@media print {
  .util_noPrint_TgMEr,
  .util_noPrint_TgMEr * {
    display: none !important;
  }
  .util_row__JstR * {
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/util.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".row {\n  display: flex;\n  align-items: center;\n  break-inside: avoid;\n}\n\n.justifiedRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.wrappingRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  max-width: 100%;\n}\n\n.column {\n  display: flex;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  max-height: 100%;\n}\n\n.centeringColumn {\n  display: flex;\n  flex-flow: column wrap;\n  align-items: center;\n  max-height: 100%;\n}\n\n.justifiedColumn {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: stretch;\n  justify-content: space-between;\n  height: 100%;\n}\n\n/* PlatformSymbol styles */\n.PScontainer {\n  display: block;\n}\n\n.PScircle {\n  fill: none;\n  stroke: var(--hsl-blue);\n  stroke-width: 3;\n}\n\n.PStext {\n  text-anchor: middle;\n  dominant-baseline: middle;\n  font-family: GothamRounded-Medium;\n  fill: var(--hsl-blue);\n}\n\n.printBtn {\n  margin-left: 2rem;\n  background-color: var(--hsl-blue);\n  margin-top: 1.5rem;\n  height: 2rem;\n  width: fit-content;\n  padding: 0 1rem 0 1rem;\n  font-size: 0.9rem;\n  border-radius: 10px;\n  color: white;\n  border: none;\n}\n\n.printBtn:hover {\n  background-color: white;\n  cursor: pointer;\n  color: var(--hsl-blue);\n  border: 1px solid var(--hsl-blue);\n}\n\n@media print {\n  .noPrint,\n  .noPrint * {\n    display: none !important;\n  }\n  .row * {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `util_row__JstR`,
	"justifiedRow": `util_justifiedRow_n2nRJ`,
	"wrappingRow": `util_wrappingRow_nQzLm`,
	"column": `util_column_rD5g8`,
	"centeringColumn": `util_centeringColumn_OCH7y`,
	"justifiedColumn": `util_justifiedColumn_ItdRH`,
	"PScontainer": `util_PScontainer_xlAzu`,
	"PScircle": `util_PScircle_nXnAN`,
	"PStext": `util_PStext_u7r3K`,
	"printBtn": `util_printBtn_KJfJ7`,
	"noPrint": `util_noPrint_TgMEr`
};
module.exports = ___CSS_LOADER_EXPORT___;
